import { DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelFundedVendor extends Layout {
    labelAdvancedComm: Label;
    labelCheck: Label;
    labelCommunications: Label;
    labelFuel: Label;
    panelAdvCommunication: Panel;
    panelAdvancedOptions: Panel;
    panelCheck: Panel;
    panelCommunications: Panel;
    panelEditFundedVendor: Panel;
    panelFuel: Panel;
    sourceFuelFundedVendor: DataSource;
    switchCommAdvOptions: Switch;
    switchFuelCreateGLEntries: Switch;
    switchHubUpdate: Switch;
    textboxAccountCode: Textbox;
    textboxCardProvider: Textbox;
    textboxCheckAPDivisonCode: Textbox;
    textboxCheckAPVoucher: Textbox;
    textboxCheckDuplicateSearch: Textbox;
    textboxCheckGLAccount: Textbox;
    textboxCheckVendorCode: Textbox;
    textboxChecksOrderReminder: Textbox;
    textboxCommunication: Textbox;
    textboxConnectionMode: Textbox;
    textboxConnectionType: Textbox;
    textboxDirectory: Textbox;
    textboxEmail: Textbox;
    textboxFuelAPDivisionCode: Textbox;
    textboxFuelAPVendorCode: Textbox;
    textboxFuelAPVoucher: Textbox;
    textboxFuelDiscount: Textbox;
    textboxFuelGLAccount: Textbox;
    textboxFuelHubVariance: Textbox;
    textboxLogin: Textbox;
    textboxPassword: Textbox;
    textboxPort: Textbox;
    textboxProxyServer: Textbox;
    textboxServerName: Textbox;
    textboxSubAccount: Textbox;
}
